export const ACTIONS = [
  'view',
  'contribute',
  'submit',
  'review',
  'approve',
  'finalize',
  'archive',
  'manage_access',
  'configure_policy',
  'export',
  'transfer_ownership',
  'administer_site',
] as const;

export type Action = (typeof ACTIONS)[number];

export const DELEGABLE_ACTIONS = [
  'view',
  'contribute',
  'submit',
  'review',
  'approve',
  'finalize',
  'archive',
  'manage_access',
  'configure_policy',
  'export',
] as const;

export type DelegableAction = (typeof DELEGABLE_ACTIONS)[number];

export function isDelegableAction(action: string): action is DelegableAction {
  return (DELEGABLE_ACTIONS as readonly string[]).includes(action);
}

export const NON_DELEGABLE_ACTIONS: readonly Action[] = ['transfer_ownership', 'administer_site'];
